import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import { ViewModeUi } from './ViewModeUi'
import { useDate } from '@/modules/drivers/stores/dateStore'
import { resolveDriverRoute } from '../../utils/resolveDriverRoute'

import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary'
import { useSideSelectionStore } from '../../stores/sideSelectionStore'

const ViewMode = ({
  padding = false,
}: {
  padding?: boolean
}) => {
  const { pathname } = useLocation()
  const { activeViewMode, selectedDriverId, basicDrivers } = useDrivers()
  const { sideCheckedIds } = useSideSelectionStore()
  const dates = useDate()

  const effectiveDriverId = React.useMemo(() => {
    if (sideCheckedIds.length > 0) return sideCheckedIds[0]
    if (selectedDriverId > 0) return selectedDriverId
    return basicDrivers[0]?.id ?? 0
  }, [sideCheckedIds, selectedDriverId, basicDrivers])

  const toggleUrl = React.useMemo(() => {
    const dateRange = dates.getDateRangeForView()
    const config = resolveDriverRoute(pathname, {
      driverId: effectiveDriverId ? effectiveDriverId.toString() : '',
      from: dateRange.from,
      to: dateRange.to,
      month: dates.month || '',
      year: dates.year || '',
    })
    const target =
      activeViewMode === 'group' ? config.routeSingle : config.routeGroup

    if (!target?.url) return ''

    // Bez rozpoznanego kierowcy `generatePath` zbuduje ucięty adres
    // (`.../timesheet/driver`), więc lepiej wyłączyć przełącznik.
    if (!effectiveDriverId && target.path.includes(':driverId')) return ''

    return target.url
  }, [activeViewMode, dates, effectiveDriverId, pathname])

  return <ViewModeUi mode={activeViewMode} padding={padding} toggleUrl={toggleUrl} />
}

const ViewModeContainer = withDefaultErrorBoundary(ViewMode)

export default ViewModeContainer
